/** Desk appearance packs — plan/36. CSS-var only; orthogonal to density. */

export const DESK_APPEARANCES = ["raised", "calm", "ink"] as const;

export type DeskAppearance = (typeof DESK_APPEARANCES)[number];

export const DESK_APPEARANCE_LABELS: Record<DeskAppearance, string> = {
  raised: "Raised",
  calm: "Calm",
  ink: "Ink",
};

/** One-line hints for the Look switcher — plan/36. */
export const DESK_APPEARANCE_HINTS: Record<DeskAppearance, string> = {
  raised: "Default craft — clearer surfaces and depth",
  calm: "Quieter prior Desk look",
  ink: "Cooler ink contrast",
};

/** Display order in the switcher (Calm → Raised → Ink). */
export const DESK_APPEARANCE_SWITCH_ORDER: readonly DeskAppearance[] = [
  "calm",
  "raised",
  "ink",
] as const;

export const DESK_APPEARANCE_STORAGE_KEY = "icraftx.deskAppearance";

/** Default craft bar — plan/36 Raised. */
export const DEFAULT_DESK_APPEARANCE: DeskAppearance = "raised";

export function parseDeskAppearance(
  raw: string | null | undefined,
): DeskAppearance {
  if (raw === "raised" || raw === "calm" || raw === "ink") return raw;
  return DEFAULT_DESK_APPEARANCE;
}

export function nextDeskAppearance(current: DeskAppearance): DeskAppearance {
  const i = DESK_APPEARANCES.indexOf(current);
  return DESK_APPEARANCES[(i + 1) % DESK_APPEARANCES.length]!;
}
